import type from '../commons/queueActionStatus';

const DEFAULT_STATE = {
    data: [],
    error: null,
    requestState: false,
    status: null,
    silentQueue: [],
};

export const queueReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let data;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    switch (actionType) {

        case type.GET_QUEUE_REQUEST:
            return { ...state, data: [], requestState, status };

        case type.GET_QUEUE_SUCCESS:
            data = action.result;
            return {
                ...state,
                data,
                requestState,
                status,
                error: null
            };

        case type.GET_QUEUE_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_SILENT_QUEUE_REQUEST:
            return { ...state, silentQueue: [], requestState, status };

        case type.GET_SILENT_QUEUE_SUCCESS:
            return {
                ...state,
                silentQueue: action.result,
                requestState,
                status,
                error: null
            };

        case type.GET_SILENT_QUEUE_FAILURE:
            return { ...state, error, requestState, status };

        case type.RESET_QUEUE_STATE:
            return {
                ...state,
                data: [],
            };

        default:
            return state;
    }
};
